import _ from 'lodash';
import moment from 'moment';
import {
  SHORT_DATE_FORMAT,
  SEARCH_DATE_FORMAT,
  TEAM_TYPES
} from 'common/constants/constants';

export const getTeamInfo = (
  selectedTimeContributorTeams,
  selectedTeams,
  currentContributorTeams,
  withMemberOfLabel
) => {
  const syncedTeams = currentContributorTeams.filter(
    ({ isSynced }) => isSynced
  );
  const teamNames = currentContributorTeams
    .filter(({ team_type }) => team_type !== TEAM_TYPES.ALL_CONTRIBUTORS)
    .map(({ team_name }) => team_name)
    .sort();
  const contributorSelectedTeams = selectedTimeContributorTeams.filter(
    contributor => selectedTeams.includes(String(contributor.team_id))
  );
  let { hasLeftOnly, info } = getHistoryInfo(contributorSelectedTeams);
  hasLeftOnly = !!hasLeftOnly;
  if (!info && withMemberOfLabel) {
    if (teamNames.length > 0) {
      const teams =
        teamNames.length === 1 ? teamNames[0] : `${teamNames.length} Teams`;
      info = `Member of ${teams}`;
    } else {
      info = 'Not in team';
    }
  }
  return {
    hasLeftOnly,
    info,
    tooltipItems: teamNames.length === 1 ? undefined : teamNames,
    syncedTeams
  };
};

export const teamsToContributorsResolver = (
  teams = [],
  from,
  to,
  isCurrentTeams
) =>
  _.chain(teams)
    .map(team => ({
      ...team,
      contributors:
        !team || !team.contributors
          ? []
          : team.contributors.map(contributor => ({
              ...contributor,
              team_id: team.id,
              team_name: team.name,
              team_type: team.type,
              isSynced: team.isSynced,
              roles: isCurrentTeams
                ? contributor.roles
                : _.chain(contributor.roles || [])
                    .sort((a, b) => moment(a.start).diff(b.start))
                    .map(({ end, start }) => {
                      const resolvedContributor = {};
                      const resolvedEnd = resolveDate(end);
                      const resolvedStart = resolveDate(start);
                      const conrtibIsStillInTeam = contributor.roles.some(
                        ({ end }) => _.isEmpty(end)
                      );
                      if (
                        (moment(resolvedEnd).isBefore(to) ||
                          moment(resolvedEnd).isSame(resolveDate(to))) &&
                        !conrtibIsStillInTeam
                      ) {
                        resolvedContributor.left_date =
                          moment(resolvedEnd).format(SHORT_DATE_FORMAT);
                      }
                      if (moment(resolvedStart).isAfter(from)) {
                        const isAfterTeamCreation =
                          resolveDate(team.established_at) !== resolvedStart;
                        if (isAfterTeamCreation) {
                          resolvedContributor.joined_date =
                            moment(resolvedStart).format(SHORT_DATE_FORMAT);
                        }
                      }
                      return _.isEmpty(resolvedContributor)
                        ? null
                        : resolvedContributor;
                    })
                    .filter(Boolean)
                    .uniqBy('left_date')
                    .uniqBy('joined_date')
                    .value()
            }))
    }))
    .flatMap(team => team.contributors)
    .groupBy('id')
    .value();

const resolveDate = date => Date.parse(moment(date).format(SEARCH_DATE_FORMAT));
export const getHistoryInfo = contributorSelectedTeams => {
  let hasLeftOnly = null;
  const infoSplitter = ' and ';
  const infos = [];
  contributorSelectedTeams.forEach(({ roles, team_name }) => {
    const roleInfos = roles
      .map(({ joined_date, left_date }) => {
        const info = [];
        if (joined_date) {
          hasLeftOnly = false;
          info.push(`Joined on ${joined_date}`);
        }
        if (left_date) {
          hasLeftOnly = hasLeftOnly !== false;
          info.push(`Left on ${left_date}`);
        }
        return info.join(infoSplitter);
      })
      .join(infoSplitter);
    if (roleInfos) {
      infos.push(roleInfos.replace(' ', ` ${team_name} `));
    }
  });
  return {
    hasLeftOnly,
    info: infos.join(', ')
  };
};
